export const getCssVariableValue = (variableName) => {
  const rootStyles = window.getComputedStyle(document.documentElement);
  return rootStyles.getPropertyValue(variableName);
};

export function disableScroll() {
  let body = document.querySelector("body");
  body.style.overflow = "hidden";
  body.style.position = "fixed";
  body.style.width = "100%";
  body.style.background = "#1D1D2B";
  // document.querySelector(".modal_black").style.display = "block";
}
export function enableScroll() {
  let body = document.querySelector("body");
  body.style.removeProperty("overflow");
  body.style.removeProperty("position");
  body.style.removeProperty("width");
  body.style.background = "var(--main-bgcolor)";
  // document.querySelector(".modal_black").style.display = "none";
}

export const isIOS = () => {
  return (
    (/iPad|iPhone|iPod|Macintosh/i.test(navigator.userAgent) &&
      "ontouchend" in document) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
};

export const isMobile = () => {
  return /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

export const checkDecimal = (number) => {
  const decimalPlaces = Number(number.toString().split(".")[1]?.length) || 0;
  const decimalScale =
    decimalPlaces > 0 ? Math.pow(10, -decimalPlaces).toFixed(decimalPlaces) : 1;

  return { decimalPlaces, decimalScale };
};
